import React from 'react';
import S from '@shared/components/S';
import Empty from 'antd/lib/empty';
import type { EmptyProps } from 'antd/lib/empty';
import styles from './BaseMessage.styles.less';

interface BaseMessageProps extends EmptyProps {
  title: React.ReactNode;
}

export function BaseMessage(props: BaseMessageProps) {
  const { title = '', ...restProps } = props;

  return (
    <Empty className={styles.bulkEntryInfoMessage} {...restProps}>
      <S size="3" bold>
        {title}
      </S>
    </Empty>
  );
}
